import { z } from "zod"
import { ContainerOptionsV1 } from "../containerOptions"

// Version 1 ---------------------
export const LottieSettingsV1 = z.object({
  width: z.string(),
  maxWidth: z.string(),
  height: z.string(),
  src: z.string(),
  loop: z.union([z.literal(true), z.literal(false)]),
  style: z.string(),
})

export type TLottieSettingsV1 = z.infer<typeof LottieSettingsV1>

export const LottieElementV1 = z.object({
  id: z.string(),
  name: z.literal("lottie"),
  settings: LottieSettingsV1,
  container: ContainerOptionsV1,
})

export type TLottieElementV1 = z.infer<typeof LottieElementV1>

// Latest ---------------------
export const LottieSettings = LottieSettingsV1
export type TLottieSettings = TLottieSettingsV1
export const LottieElement = LottieElementV1
export type TLottieElement = TLottieElementV1
